import PropTypes from "prop-types";
import React from "react";

import useListPermission from "../../hooks/useListPermission";
import Loading from "../loading";

/**
 * A container that renders its children only if the user has the required permission.
 * While checking, it shows a loading indicator. If permission is denied,
 * it can either redirect to the home page or render nothing.
 *
 * @param {object} props The component props.
 * @param {React.ReactNode} props.children The content to render if permission is granted.
 * @param {string} props.permission The permission string to validate.
 * @param {boolean} [props.returnNull=false] If true, renders null instead of redirecting on permission failure.
 */
const PermissionContainer = ({ children, permission, returnNull = false }) => {
  const { hasPermission } = useListPermission(permission);

  if (hasPermission === undefined) {
    return <Loading />;
  }

  if (hasPermission) {
    return <>{children}</>;
  }

  return returnNull ? null : (window.location.href = "/");
};

PermissionContainer.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.string.isRequired,
  returnNull: PropTypes.bool,
};

export default PermissionContainer;
